import {all, call, put, takeEvery} from 'redux-saga/effects';
import {BusinessEntityActionTypes} from "./types";
import {fetchError, fetchSuccess, fetchListSuccess} from "./action";
import ServiceManager from "../../services/ServiceManager";
import {AxiosResponse} from "axios";
import {PaginationMeta} from "../types";
import {handleError} from "../saga";
import {BusinessEntity} from "../../models/BusinessEntity";
import {addToast} from "../action";
import {push} from 'connected-react-router'

/**
 * @param action
 */
function* handleFetch(action: any) {
    try {
        const response: AxiosResponse = yield call([
            ServiceManager.dataApi.business_entity,
            ServiceManager.dataApi.business_entity.getById
        ], action.payload);
        const businessEntity: BusinessEntity = response.data.data as BusinessEntity;
        yield put(fetchSuccess({data: businessEntity}));
    } catch (err) {
        handleError(err);
        yield put(fetchError(err?.response?.data?.message));
    }
}

/**
 * @param action
 */
function* handleListRequest(action: any) {
    try {
        const response: AxiosResponse = yield call(
            [
                ServiceManager.dataApi.business_entity,
                ServiceManager.dataApi.business_entity.findAll
            ],
            action.payload.pageSize || 20,
            action.payload.pageNumber || 1,
            {}
        );

        const listOfBankAccounts: BusinessEntity[] = response.data.data as BusinessEntity[];
        const paginationMeta: PaginationMeta = response.data.meta as PaginationMeta;
        yield put(fetchListSuccess({
            list: listOfBankAccounts, paginationMeta
        }))
    } catch (err) {
        handleError(err);
        yield put(fetchError(err.message))
    }
}

function* handleCreate(action: any) {
    try {
        const response: AxiosResponse = yield call(
            [
                ServiceManager.dataApi.business_entity,
                'create'
            ],
            action.payload.data
        )

        const businessEntity: BusinessEntity = response.data.data as BusinessEntity;
        yield put(fetchSuccess({data: businessEntity}));
        yield put(addToast("Business saved successfully.", "success"));
        yield put(push(`/businesses/${response.data.data.id}/edit`))
        // window.location.reload();
        window.location.href = `/businesses/${response.data.data.id}/edit`;
    } catch (err) {
        handleError(err);
        yield put(fetchError(err?.response?.data?.message));
        yield put(fetchError(err.message))
    }
}

/**
 * @param action
 */
function* handleUpdate(action: any) {
    try {
        const response: AxiosResponse = yield call(
            [
                ServiceManager.dataApi.business_entity,
                'update'
            ],
            action.payload.id,
            action.payload.data
        )

        const businessEntity: BusinessEntity = response.data.data as BusinessEntity;
        yield put(fetchSuccess({data: businessEntity}));
        yield put(addToast("Business updated successfully.", "success"));
    } catch (err) {
        handleError(err);
        yield put(fetchError(err?.response?.data?.message));
    }
}

function* watchFetchRequest() {
    yield takeEvery(BusinessEntityActionTypes.FETCH_LIST_REQUEST, handleListRequest)
    yield takeEvery(BusinessEntityActionTypes.FETCH_REQUEST, handleFetch);
    yield takeEvery(BusinessEntityActionTypes.CREATE_REQUEST, handleCreate);
    yield takeEvery(BusinessEntityActionTypes.UPDATE_REQUEST, handleUpdate);
}

function* businessEntitiesSaga() {
    yield all([
        watchFetchRequest()
    ]);
}

export default businessEntitiesSaga;
